import dayjs from "dayjs";

import { BUSINESS_TIMEZONE } from "./businessDay";

export const getYesterdayTimeframe = (now?: dayjs.ConfigType) => {
    const yesterday = dayjs(now).tz(BUSINESS_TIMEZONE).subtract(1, "day").format("MM-DD-YYYY");
    return {
        start: `${yesterday} 00:00:00`,
        end: `${yesterday} 23:59:59`,
    };
};
